<div class="w-full" [class.mb-4]="!noMargin" [formGroup]="formGroup">
  <!-- External Label (like in auth component) -->
  <label *ngIf="label" class="block text-sm font-medium text-gray-700 mb-2">
    {{ label }}
    <span *ngIf="required" class="text-red-500 ml-1">*</span>
  </label>

  <!-- Material Form Field with Custom Styling -->
  <div class="relative">
    <mat-form-field 
      [appearance]="'fill'" 
      [floatLabel]="'auto'"
      class="w-full custom-textbox-field">
      
      <!-- Hidden Label (since we show it externally) -->
      <mat-label style="display: none;"></mat-label>

      <!-- Input Field -->
        <input 
            matInput
            [type]="type"
            [placeholder]="placeholder"
            [disabled]="isDisabled"
            [maxlength]="maxLength"
            [minlength]="minLength"
            [pattern]="pattern"
            [value]="value"
            [formControlName]="fControlName"
            (input)="onInput($event)"
            (blur)="onBlur()"
            class="custom-input"
            autocomplete="off"
            [required]="required"
        >

        <!-- <input 
            *ngIf="isFormControl && formControl"
            matInput
            [type]="type"
            [placeholder]="placeholder"
            [disabled]="isDisabled"
            [maxlength]="maxLength"
            [minlength]="minLength"
            [value]="value"
            [formControl]="formControl"
            (input)="onInput($event)"
            (blur)="onBlur()"
            class="custom-input"
            autocomplete="off"
        >

        <input 
            *ngIf="!isFormControl"
            matInput
            [type]="type"
            [placeholder]="placeholder"
            [disabled]="isDisabled"
            [maxLength]="maxLength"
            [minLength]="minLength"
            [value]="value"
            (input)="onInput($event)"
            (blur)="onBlur()"
            class="custom-input"
            autocomplete="off"
        > -->

    </mat-form-field>

    <!-- Suffix Icon (positioned absolutely like auth component) -->
    <mat-icon *ngIf="suffixIcon" class="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 !text-lg !leading-none">
      {{ suffixIcon }}
    </mat-icon>
  </div>

  <!-- Error Messages (styled like auth component) -->
    <ng-container *ngIf="hasError">
        <div *ngFor="let error of errorMessages" class="text-red-500 text-sm mt-1">
            {{ error }}
        </div>
    </ng-container>

  <!-- Character Count -->
  <div *ngIf="maxLength" class="text-xs text-gray-500 mt-1 text-right">
    {{ value?.length || 0 }}/{{ maxLength }}
  </div>
</div>
